<template lang="pug">
a(
  :href="disabled ? null : finalUrl"
  :disabled="disabled"
  :class="{ active: active }"
  @click="onClick"
)
  slot
</template>

<script>
export default {
  name: 'AppLink',
  props: {
    url: { type: String },
    href: { type: String },
    format: { type: String },
    urlQuery: { type: Object, default: () => ({}) },
    urlQueryOverrides: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    finalUrl() {
      const params = { ...this.urlQuery, ...this.urlQueryOverrides };
      let url = this.url;

      if (this.format) {
        url = `${url}.${this.format}`;
      }
      if ($.param(params)) {
        url = `${url}?${$.param(params)}`;
      }

      return url;
    },
  },
  methods: {
    onClick(e) {
      if (!this.disabled) {
        this.$emit('click', { format: this.format });
      }
    },
  },
};
</script>
